module.exports = __webpack_public_path__ + "static/media/comp-washing-s.0aa13a73.webp";